export function formatNumber(value: string): string {
  const matcher = /^(\d+)[.,]?(\d+)?$/;
  if (!matcher.test(value)) return value;

  const [decimal, floating = ''] = value.split(/[.,]/);
  return `${decimal},${floating.slice(0, 2).padEnd(2, '0')}`;
}
